import {
  TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING,
  TRESPONSE_PROCESS_LISTING,
  TRESPONSE_PROCESS_MAP_LISTING,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TProcessMappingInfoActionType } from './process-mapping.models';

export class FetchProcessListing implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessListing;
  constructor() {}
}
export class FetchProcessListingSuccess implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessListingSuccess;
  constructor(public payload: TRESPONSE_PROCESS_LISTING) {}
}
export class FetchProcessListingFailure implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessListingFailure;
  constructor() {}
}

export class FetchProcessMapListing implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessMapListing;
  constructor() {}
}
export class FetchProcessMapListingSuccess implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessMapListingSuccess;
  constructor(public payload: TRESPONSE_PROCESS_MAP_LISTING) {}
}
export class FetchProcessMapListingFailure implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessMapListingFailure;
  constructor() {}
}

export class FetchProcessFactoryAssignListing implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessFactoryAssignListing;
  constructor() {}
}
export class FetchProcessFactoryAssignListingSuccess implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessFactoryAssignListingSuccess;
  constructor(public payload: TRESPONSE_GET_PROCESS_FACTORY_ASSIGN_LISTING) {}
}
export class FetchProcessFactoryAssignListingFailure implements Action {
  readonly type = TProcessMappingInfoActionType.FetchProcessFactoryAssignListingFailure;
  constructor() {}
}

export type TProcessMappingActions =
  | FetchProcessListing
  | FetchProcessListingSuccess
  | FetchProcessListingFailure
  | FetchProcessMapListing
  | FetchProcessMapListingSuccess
  | FetchProcessMapListingFailure
  | FetchProcessFactoryAssignListing
  | FetchProcessFactoryAssignListingSuccess
  | FetchProcessFactoryAssignListingFailure;
